{
  "nav": {
    "groups": {
      "personal": "Personal",
      "productivity": "Productivity",
      "pipeline": "Pipeline",
      "firm_wide": "Firm Wide"
    },
    "items": {
      "my_contacts": "My Contacts",
      "contacts": "Contacts",
      "my_companies": "My Companies",
      "companies": "Companies",
      "my_lists": "My Lists",
      "lists": "Lists",
      "my_journey": "My Journey",
      "tasks": "Tasks",
      "my_tasks": "My Tasks",
      "calendar": "Calendar",
      "my_calendar": "My Calendar",
      "workspaces": "Workspaces",
      "apps": "Apps",
      "objectives": "Objectives",
      "my_objectives": "My Objectives",
      "stay_in_touch": "Stay in Touch",
      "prospecting": "Prospecting",
      "my_prospects": "My Prospects",
      "opportunities": "Opportunities",
      "my_opportunities": "My Opportunities",
      "key_activities": "Key Activities",
      "all_contacts": "All Contacts",
      "all_companies": "All Companies",
      "marketing_lists": "Marketing Lists",
      "campaigns": "Campaigns",
      "all_prospects": "All Prospects",
      "all_opportunities": "All Opportunities",
      "all_objectives": "All Objectives",
      "referrals": "Referrals",
      "sent_referrals": "Sent Referrals",
      "received_referrals": "Received Referrals",
      "reports": "Reports",
      "all_reports": "All Reports"
    },
    "admin": {
      "data_cleaner": "Data Cleaner",
      "reporting": "Reporting",
      "user_management": "User Management",
      "tag_management": "Tag Management",
      "import": "Import",
      "activity_titles": "Activity Titles",
      "internal_industries": "Internal Industries",
      "forms": "Forms",
      "industry_mapper": "Industry Mapper",
      "ems_setup": "EMS Setup",
      "marketing_contacts": "Marketing Contacts"
    },
    "create_menu": {
      "create": "Create",
      "contact": "Contact",
      "company": "Company",
      "opportunity": "Opportunity",
      "task": "Task",
      "nexl_ai": "Nexl AI"
    },
    "tooltips": {
      "notifications": "Notifications",
      "admin": "Admin"
    },
    "alt_text": {
      "go_to_dashboard": "go to dashboard",
      "go_to_home": "go to home"
    },
    "teams": {
      "project": "Project"
    }
  },
  "headers": {
    "search_prospects": "Search for New Prospects",
    "nexl_apps": "NEXL Apps",
    "marketing_exclusion_rules": "Marketing Exclusion Rules"
  },
  "settings": {
    "language": "Language"
  }
}
